import type Phaser from 'phaser';
import type { CombatProjectile } from '@/domain/combat/projectile';

const TYPE_COLOR: Record<CombatProjectile['type'], number> = {
  Fire: 0xff6a45,
  Water: 0x55cfff,
  Earth: 0xc99a62,
  Air: 0xe8fbff,
  Life: 0x7ee787,
  Shadow: 0xb187ff,
};

export interface ProjectileRendererHandle {
  id: string;
  update(projectile: CombatProjectile): void;
  destroy(): void;
}

export function buildProjectileRenderer(scene: Phaser.Scene, projectile: CombatProjectile): ProjectileRendererHandle {
  const container = scene.add.container(projectile.x, projectile.y).setDepth(12);
  const glow = scene.add.circle(0, 0, projectile.radius + 3, TYPE_COLOR[projectile.type], 0.22);
  const core = scene.add.circle(0, 0, projectile.radius, TYPE_COLOR[projectile.type], 1).setStrokeStyle(1, 0xffffff, 0.9);
  container.add([glow, core]);
  return {
    id: projectile.id,
    update(next) {
      container.setPosition(Math.round(next.x), Math.round(next.y));
    },
    destroy() {
      container.destroy();
    },
  };
}
